module.exports = __webpack_public_path__ + "static/capitalism-without-capital-5bc4f171b66c75d1bcff9852417e4fe7.jpg";